import api from './axios';

export const getSettingsApi = () => api.get('/admin/settings');
export const updateSettingApi = (key, data) => api.put(`/admin/settings/${key}`, data);
export const getMessagingRulesApi = () => api.get('/admin/settings/messaging/rules');
export const updateMessagingRulesApi = (data) => api.put('/admin/settings/messaging/rules', data);
export const getProductTogglesApi = () => api.get('/admin/settings/products/toggles');
export const getTaxonomyApi = () => api.get('/admin/settings/taxonomy');
export const getAdminRolesApi = () => api.get('/admin/settings/roles');
